import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import React, { useEffect } from "react";
import { graphql, useQueryLoader } from "react-relay";

import { accountAtom } from "shared/lib/account";

import { ClientSideSuspense } from "scmp-app/components/common/client-side-suspense";
import type { contentReactionQuery } from "scmp-app/queries/__generated__/contentReactionQuery.graphql";

import type { Props as ContentReactionDisplayProps } from "./content-reaction-display";
import { ContentReactionDisplay } from "./content-reaction-display";
import { withUserServiceEnvironment } from "./hoc";

export type Props = Omit<ContentReactionDisplayProps, "queryReference">;

export const query = graphql`
  query contentReactionQuery($entityId: String!, $isLoggedIn: Boolean!) {
    ...contentReactionDisplayQuery @arguments(entityId: $entityId, isLoggedIn: $isLoggedIn)
  }
`;

const Component: FunctionComponent<Props> = ({ entityId, ...props }) => {
  const { isLoggedIn } = useAtomValue(accountAtom);
  const [queryReference, loadQuery, disposeQuery] = useQueryLoader<contentReactionQuery>(query);

  useEffect(() => {
    loadQuery({ entityId, isLoggedIn });
    return disposeQuery;
  }, [loadQuery, disposeQuery, isLoggedIn, entityId]);

  return (
    <ClientSideSuspense>
      {queryReference && (
        <ContentReactionDisplay entityId={entityId} queryReference={queryReference} {...props} />
      )}
    </ClientSideSuspense>
  );
};

Component.displayName = "ContentReaction";
export const ContentReaction = withUserServiceEnvironment(Component);
